import React from 'react';
import clsx from 'clsx';
import { Tooltip } from '@components/main-components/tooltip/Tooltip';
import { BridgeModal } from '@components/modals/Bridge';
import { MediaQuery } from '@context/mediaQuery';
import { ModalContext, ModalType } from '@context/modal';
import { humanReadableChainName } from '@utils/helpers';
import { EthereumIndicator, OptimismIndicator } from './ChainIndicators';

export const NetworkIndicator = ({
  chainId,
  size = 'sm',
}: {
  chainId: number;
  size?: 'sm' | 'md';
}) => {
  const { openModal } = ModalContext.useContainer();
  const currentNetwork = humanReadableChainName(chainId);

  const { tabletLandscape } = MediaQuery.useContainer();

  if (currentNetwork === 'UNKNOWN') return null;

  const isOptimism = currentNetwork === 'Optimism';
  return (
    <Tooltip openOnClick={!tabletLandscape} delayCloseMs={isOptimism ? 1000 : undefined}>
      <Tooltip.Trigger
        className={clsx(
          'flex overflow-visible transition-opacity md:hover:opacity-100 [&_svg]:overflow-visible ',
          'data-[state=closed]:opacity-30 data-[state=instant-open]:opacity-100',
          size === 'md' ? 'w-5 [&_svg]:w-5' : 'w-4 [&_svg]:w-4',
        )}
      >
        {isOptimism ? <OptimismIndicator /> : <EthereumIndicator />}
      </Tooltip.Trigger>
      <Tooltip.StyledContent size="sm" className="rounded-sm p-2 text-center">
        {currentNetwork} Network
        {isOptimism && (
          <>
            <br />
            Bridge your ETH&nbsp;
            <button
              className="underline"
              onClick={e => {
                e.stopPropagation();
                openModal(ModalType.BRIDGE_MODAL, {
                  body: <BridgeModal />,
                });
              }}
            >
              here
            </button>
            .
          </>
        )}
      </Tooltip.StyledContent>
    </Tooltip>
  );
};
